/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_Price_NoteInputs */

const en_marketing_engagement_price_note = /** @type {(inputs: Marketing_Engagement_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with every engagement`)
};

const es_marketing_engagement_price_note = /** @type {(inputs: Marketing_Engagement_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`con cada colaboración`)
};

const fr_marketing_engagement_price_note = /** @type {(inputs: Marketing_Engagement_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avec chaque mission`)
};

/**
* | output |
* | --- |
* | "with every engagement" |
*
* @param {Marketing_Engagement_Price_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_price_note = /** @type {((inputs?: Marketing_Engagement_Price_NoteInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_Price_NoteInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_price_note(inputs)
	if (locale === "es") return es_marketing_engagement_price_note(inputs)
	return fr_marketing_engagement_price_note(inputs)
});